import { reportApi } from './reportApi';

// Coalesce identical in-flight reads only. Completed results are never cached,
// so returns, uploads and edits are visible immediately on the next refresh.
const requests = new Map();
export const subscribeReport = (path, userId) => {
  const [route, query = ''] = path.split('?');
  const params = new URLSearchParams(query); params.sort();
  const url = query ? `${route}?${params}` : route;
  const key = `${userId || ''}:${url}`;
  let entry = requests.get(key);
  if (!entry) {
    const controller = new AbortController();
    entry = { controller, listeners: 0 };
    entry.promise = reportApi.get(url, { signal: controller.signal }).finally(() => {
      if (requests.get(key) === entry) requests.delete(key);
    });
    requests.set(key, entry);
  }
  entry.listeners++;
  let released = false;
  return {
    promise: entry.promise,
    release: () => {
      if (released) return;
      released = true;
      entry.listeners--;
      if (!entry.listeners && requests.get(key) === entry) {
        requests.delete(key);
        entry.controller.abort();
      }
    },
  };
};